export const FAQ = [
  {
    q: "Who owns and operates Vinconex?",
    a: "Vinconex is built, owned and operated by CraveBeast LLC. Reach the team any time at contact@vinconex.com.",
  },
  {
    q: "What is Vinconex?",
    a: "Vinconex puts a smart QR sticker on every vehicle on your lot. Shoppers scan it to a page in your dealership's branding with live pricing, photos, CARFAX on pre-owned and a payment calculator — and their lead lands in your CRM as ADF XML.",
  },
  {
    q: "What's included in the Basic package?",
    a: "QR window stickers (with Stock # and VIN printed into the code), branded vehicle landing pages synced from your website, CARFAX + payment links, \"Text me this vehicle\" and new-arrival leads delivered to your CRM, admin and manager logins, a dealer public page and a new-arrivals page.",
  },
  {
    q: "What is the Specialist Match add-on?",
    a: "An optional add-on. Shoppers take a 4-question DISC-style style check and are paired with the product specialist who sells the way they buy. Managers score follow-up and completed tasks from your CRM, which steers who gets the lead. The matched specialist rides inside the ADF lead.",
  },
  {
    q: "How does inventory get into Vinconex?",
    a: "We sync directly from your public dealership website — no feed or IT work required. Discovery runs in seconds; pricing, photos and specs refresh in the background, and an overnight scan archives vehicles that left your site.",
  },
  {
    q: "What happens to a QR sticker after the car sells?",
    a: "The code keeps working. Anyone who scans it is sent to Vinconex with a note that the vehicle has found a new home and a link to what's new at your dealership — so a leftover sticker never dead-ends.",
  },
  {
    q: "How do leads reach my CRM?",
    a: "Every lead is emailed to your CRM's lead inbox as ADF XML (works with DriveCentric, VinSolutions, DealerSocket, eLead and any ADF-compatible CRM). You set the inbox once in Settings and can send a test lead any time.",
  },
  {
    q: "How do I print stickers?",
    a: "From Inventory, print one vehicle, a selection, or the whole lot. Choose 1, 2 or 4 stickers per Letter page in portrait or landscape and send it to any standard printer.",
  },
  {
    q: "Can I use Vinconex as an app?",
    a: "Yes — it installs as a web app on iOS and Android from your browser, and native App Store / Google Play shells are available for dealer groups.",
  },
  {
    q: "How much does it cost?",
    a: "Pricing depends on rooftop count and whether you add Specialist Match. Send us a note with your dealership and we'll get you a quote within one business day.",
  },
];
